import { AUTH_ENDPOINTS } from "./auth";
import { request } from "@/utils/request";
import {userRoles} from "../constants/userRoles";

const userKey = "user";
const accessTokenKey = "access_token";

class User {
  user = null;
  tokenBearer = "Bearer";

  get() {
    if (this.user) {
      return this.user;
    }
    const savedUser = localStorage.getItem(userKey);
    if (savedUser) {
      this.user = JSON.parse(savedUser);
      return this.user;
    }
  }

  async clear() {
    const token = this.getToken();
    this.user = null;
    localStorage.removeItem(userKey);
    localStorage.removeItem(accessTokenKey);
    if (token) {
      await request({
        skipRedirect: true,
        url: AUTH_ENDPOINTS.logout,
        query: {
          token,
        },
        method: "POST",
      });
    }
  }

  async set(value) {
    localStorage.setItem(userKey, JSON.stringify(value));
    if (value.accessToken) {
      // lazy-table requires access_token
      localStorage.setItem(accessTokenKey, value.accessToken);
    }
    const userInfo = await this.getMeta();
    const userData = { ...userInfo, ...value };
    localStorage.setItem(userKey, JSON.stringify(userData));
    this.user = userData;
  }

  getToken() {
    return this.get()?.accessToken;
  }

  setToken(token) {
    return this.set({ accessToken: token });
  }

  getAuthorization() {
    return `${this.tokenBearer} ${this.getToken()}`;
  }

  getLanguage() {
    return this.get()?.language;
  }

  setLanguage(language) {
    return this.set({ ...this.get(), language });
  }

  isAdministrator() {
    return this.get()?.role === userRoles.Admin;
  }

  isSuperUser() {
    const user = this.get()
    return user?.role === userRoles.SuperUser;
  }

  hasRole(role) {
    return this.get()?.role === role || this.isAdministrator()
  }

  async getMeta() {
    const { data } = await request({
      url: AUTH_ENDPOINTS.currentUser,
    });

    return data;
  }
}

export const ActiveUser = new User();
